import {useQuery} from '@apollo/react-hooks';
import React from 'react';
import {useParams} from 'react-router';
import {useObsidianContext} from '../../../../../context/ObsidianProvider';
import {useQueueContext} from '../../../../../context/QueueProvider';
import {BackNavigation} from '../../../../Workspace/components/Header/components';
import {PlaylistDetails} from '../../components/PlaylistDetails';
import {PLAYLIST_VIEW_QUERY, CATALOG_PLAYLIST_VIEW_QUERY} from './graphql';
import {
  PlaylistViewQuery,
  CatalogPlaylistViewQuery,
  PlaylistViewQueryVariables,
  CatalogPlaylistViewQueryVariables,
} from './graphql/types';
import styles from './PlaylistView.module.scss';

interface Props {
  catalog?: boolean;
}

export function PlaylistView({catalog}: Props) {
  const {id} = useParams<{id: string}>();
  const {obsidian} = useObsidianContext();
  const {setUpNext} = useQueueContext();

  const {data: libraryData} = useQuery<
    PlaylistViewQuery,
    PlaylistViewQueryVariables
  >(PLAYLIST_VIEW_QUERY, {
    variables: {
      id,
    },
    skip: catalog,
    fetchPolicy: 'cache-and-network',
  });

  const {data: catalogData} = useQuery<
    CatalogPlaylistViewQuery,
    CatalogPlaylistViewQueryVariables
  >(CATALOG_PLAYLIST_VIEW_QUERY, {
    variables: {
      id,
    },
    skip: !catalog,
    fetchPolicy: 'cache-and-network',
  });

  const playlist = catalog
    ? catalogData?.music?.playlist
    : libraryData?.me?.library?.playlist;

  return (
    <>
      <BackNavigation />
      <br />
      {playlist ? (
        <div className={styles.ViewContainer}>
          <PlaylistDetails
            id={playlist.id}
            name={playlist.name}
            curatorName={playlist.curatorName || ''}
            artwork={playlist.artwork?.largeUrl || ''}
            tracks={playlist.tracks}
            trackCount={playlist.tracks.length}
            likes={69}
            onPlay={() => {
              obsidian.play(playlist.tracks[0]);
              setUpNext(playlist.tracks.slice(1));
            }}
          />
        </div>
      ) : (
        'loading...'
      )}
    </>
  );
}
